import styled, { keyframes } from 'styled-components';

const grow = keyframes`
        from {
            transform: scale(0);
        }
        to {
            transform: scale(1);
        }
`;

export const Tick = styled.div`
  position: absolute;
  right: 32px;
  top: 26px;
  animation: ${grow} 1.8s ease-in-out;

  @media (max-width: ${(props) => props.theme.breakPoints.mobileL}) {
    right: ${(props) => (props.pincode ? 'auto' : '16px')};
    left: ${(props) => (props.pincode ? '49%' : 'auto')};
    display: ${(props) => (props.stateTick ? 'none' : 'block')};
  }

  img {
    width: clamp(13px, 2vw, 16px);
    height: clamp(13px, 2vw, 16px);
  }
`;
